

export const REGISTER_USER_REQUEST = "REGISTER_USER_REQUEST";
export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
export const REGISTER_USER_RESET = "REGISTER_USER_RESET";
export const REGISTER_USER_FAIL = "REGISTER_USER_FAIL";


export const CONTACT_REQUEST = "CONTACT_REQUEST";
export const CONTACT_SUCCESS = "CONTACT_SUCCESS";
export const CONTACT_RESET = "CONTACT_RESET";
export const CONTACT_FAIL = "CONTACT_FAIL";


export const MANUAL_REGISTER_REQUEST = "MANUAL_REGISTER_REQUEST";
export const MANUAL_REGISTER_SUCCESS = "MANUAL_REGISTER_SUCCESS";
export const MANUAL_REGISTER_RESET = "MANUAL_REGISTER_RESET";
export const MANUAL_REGISTER_FAIL = "MANUAL_REGISTER_FAIL";


export const VERIFY_TIME_REQUEST = "VERIFY_TIME_REQUEST";
export const VERIFY_TIME_SUCCESS = "VERIFY_TIME_SUCCESS";
export const VERIFY_TIME_FAIL = "VERIFY_TIME_FAIL";

export const VERIFY_TOKEN_REQUEST = "VERIFY_TOKEN_REQUEST";
export const VERIFY_TOKEN_SUCCESS = "VERIFY_TOKEN_SUCCESS";
export const VERIFY_TOKEN_FAIL = "VERIFY_TOKEN_FAIL";


export const RESEND_EMAIL_REQUEST = "RESEND_EMAIL_REQUEST";
export const RESEND_EMAIL_SUCCESS = "RESEND_EMAIL_SUCCESS";
export const RESEND_EMAIL_RESET = "RESEND_EMAIL_RESET";
export const RESEND_EMAIL_FAIL = "RESEND_EMAIL_FAIL";

export const VERIFY_EMAIL_REQUEST = "VERIFY_EMAIL_REQUEST";
export const VERIFY_EMAIL_SUCCESS = "VERIFY_EMAIL_SUCCESS";
export const VERIFY_EMAIL_FAIL = "VERIFY_EMAIL_FAIL";


export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAIL = "LOGOUT_FAIL";

export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";


export const LOAD_USER_REQUEST = "LOAD_USER_REQUEST";
export const LOAD_USER_SUCCESS = "LOAD_USER_SUCCESS";
export const LOAD_USER_FAIL = "LOAD_USER_FAIL";


export const FORGET_PASSWORD_REQUEST = "FORGET_PASSWORD_REQUEST";
export const FORGET_PASSWORD_SUCCESS = "FORGET_PASSWORD_SUCCESS";
export const FORGET_PASSWORD_RESET = "FORGET_PASSWORD_RESET";
export const FORGET_PASSWORD_FAIL = "FORGET_PASSWORD_FAIL";

export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAIL = "RESET_PASSWORD_FAIL";



export const INVITE_USER_REQUEST = "INVITE_USER_REQUEST";
export const INVITE_USER_SUCCESS = "INVITE_USER_SUCCESS";
export const INVITE_USER_RESET = "INVITE_USER_RESET";
export const INVITE_USER_FAIL = "INVITE_USER_FAIL";


export const SAVE_SETTINGS_REQUEST = "SAVE_SETTINGS_REQUEST";
export const SAVE_SETTINGS_SUCCESS = "SAVE_SETTINGS_SUCCESS";
export const SAVE_SETTINGS_RESET = "SAVE_SETTINGS_RESET";
export const SAVE_SETTINGS_FAIL = "SAVE_SETTINGS_FAIL";

export const LOAD_SETTINGS_REQUEST = "LOAD_SETTINGS_REQUEST";
export const LOAD_SETTINGS_SUCCESS = "LOAD_SETTINGS_SUCCESS";
export const LOAD_SETTINGS_FAIL = "LOAD_SETTINGS_FAIL";


export const CREATE_CATEGORY_REQUEST = "CREATE_CATEGORY_REQUEST";
export const CREATE_CATEGORY_SUCCESS = "CREATE_CATEGORY_SUCCESS";
export const CREATE_CATEGORY_RESET = "CREATE_CATEGORY_RESET";
export const CREATE_CATEGORY_FAIL = "CREATE_CATEGORY_FAIL";

export const TOGGLE_CATEGORY_REQUEST = "TOGGLE_CATEGORY_REQUEST";
export const TOGGLE_CATEGORY_SUCCESS = "TOGGLE_CATEGORY_SUCCESS";
export const TOGGLE_CATEGORY_RESET = "TOGGLE_CATEGORY_RESET";
export const TOGGLE_CATEGORY_FAIL = "TOGGLE_CATEGORY_FAIL";

export const ALL_CATEGORIES_REQUEST = "ALL_CATORIES_REQUEST";
export const ALL_CATEGORIES_SUCCESS = "ALL_CATORIES_SUCCESS";
export const ALL_CATEGORIES_FAIL = "ALL_CATORIES_FAIL";

export const ALL_INVITES_REQUEST = "ALL_INVITES_REQUEST";
export const ALL_INVITES_SUCCESS = "ALL_INVITES_SUCCESS";
export const ALL_INVITES_FAIL = "ALL_INVITES_FAIL";



export const CREATE_PRODUCT_TYPE_REQUEST = "CREATE_PRODUCT_TYPE_REQUEST";
export const CREATE_PRODUCT_TYPE_SUCCESS = "CREATE_PRODUCT_TYPE_SUCCESS";
export const CREATE_PRODUCT_TYPE_RESET = "CREATE_PRODUCT_TYPE_RESET";
export const CREATE_PRODUCT_TYPE_FAIL = "CREATE_PRODUCT_TYPE_FAIL";

export const TOGGLE_PRODUCT_TYPE_REQUEST = "TOGGLE_PRODUCT_TYPE_REQUEST";
export const TOGGLE_PRODUCT_TYPE_SUCCESS = "TOGGLE_PRODUCT_TYPE_SUCCESS";
export const TOGGLE_PRODUCT_TYPE_RESET = "TOGGLE_PRODUCT_TYPE_RESET";
export const TOGGLE_PRODUCT_TYPE_FAIL = "TOGGLE_PRODUCT_TYPE_FAIL";

export const ALL_PRODUCT_TYPES_REQUEST = "ALL_PRODUCT_TYPES_REQUEST";
export const ALL_PRODUCT_TYPES_SUCCESS = "ALL_PRODUCT_TYPES_SUCCESS";
export const ALL_PRODUCT_TYPES_FAIL = "ALL_PRODUCT_TYPES_FAIL";

export const ADD_DETAILS_REQUEST = "ADD_DETAILS_REQUEST";
export const ADD_DETAILS_SUCCESS = "ADD_DETAILS_SUCCESS";
export const ADD_DETAILS_RESET = "ADD_DETAILS_RESET";
export const ADD_DETAILS_FAIL = "ADD_DETAILS_FAIL";


export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_RESET = "CHANGE_PASSWORD_RESET";
export const CHANGE_PASSWORD_FAIL = "CHANGE_PASSWORD_FAIL";




export const ALL_USERS_REQUEST = "ALL_USERS_REQUEST";
export const ALL_USERS_SUCCESS = "ALL_USERS_SUCCESS";
export const ALL_USERS_FAIL = "ALL_USERS_FAIL";

export const ALL_PENDING_USERS_REQUEST = "ALL_PENDING_USERS_REQUEST";
export const ALL_PENDING_USERS_SUCCESS = "ALL_PENDING_USERS_SUCCESS";
export const ALL_PENDING_USERS_FAIL = "ALL_PENDING_USERS_FAIL";


export const UPDATE_USER_STATUS_REQUEST = "UPDATE_USER_STATUS_REQUEST";
export const UPDATE_USER_STATUS_SUCCESS = "UPDATE_USER_STATUS_SUCCESS";
export const UPDATE_USER_STATUS_RESET = "UPDATE_USER_STATUS_RESET";
export const UPDATE_USER_STATUS_FAIL = "UPDATE_USER_STATUS_FAIL";

export const APPROVE_USER_REQUEST = "APPROVE_USER_REQUEST";
export const APPROVE_USER_SUCCESS = "APPROVE_USER_SUCCESS";
export const APPROVE_USER_RESET = "APPROVE_USER_RESET";
export const APPROVE_USER_FAIL = "APPROVE_USER_FAIL";

export const CREATE_BLOCKED_EMAIL_REQUEST = "CREATE_BLOCKED_EMAIL_REQUEST";
export const CREATE_BLOCKED_EMAIL_SUCCESS = "CREATE_BLOCKED_EMAIL_SUCCESS";
export const CREATE_BLOCKED_EMAIL_FAIL = "CREATE_BLOCKED_EMAIL_FAIL";
export const CREATE_BLOCKED_EMAIL_RESET = "CREATE_BLOCKED_EMAIL_RESET";

export const UPDATE_PRODUCT_TYPE_REQUEST = "UPDATE_PRODUCT_TYPE_REQUEST";
export const UPDATE_PRODUCT_TYPE_SUCCESS = "UPDATE_PRODUCT_TYPE_SUCCESS";
export const UPDATE_PRODUCT_TYPE_FAIL = "UPDATE_PRODUCT_TYPE_FAIL";
export const UPDATE_PRODUCT_TYPE_RESET = "UPDATE_PRODUCT_TYPE_RESET";



export const ALL_BLOCKED_EMAIL_REQUEST = "ALL_BLOCKED_EMAIL_REQUEST";
export const ALL_BLOCKED_EMAIL_SUCCESS = "ALL_BLOCKED_EMAIL_SUCCESS";
export const ALL_BLOCKED_EMAIL_FAIL = "ALL_BLOCKED_EMAIL_FAIL";


export const UPDATE_AVATAR_REQUEST = "UPDATE_AVATAR_REQUEST";
export const UPDATE_AVATAR_SUCCESS = "UPDATE_AVATAR_SUCCESS";
export const UPDATE_AVATAR_RESET = "UPDATE_AVATAR_RESET";
export const UPDATE_AVATAR_FAIL = "UPDATE_AVATAR_FAIL";

export const DELETE_BLOCKED_EMAIL_REQUEST = "DELETE_BLOCKED_EMAIL_REQUEST";
export const DELETE_BLOCKED_EMAIL_SUCCESS = "DELETE_BLOCKED_EMAIL_SUCCESS";
export const DELETE_BLOCKED_EMAIL_RESET = "DELETE_BLOCKED_EMAIL_RESET";
export const DELETE_BLOCKED_EMAIL_FAIL = "DELETE_BLOCKED_EMAIL_FAIL";




export const ALL_ADMINS_REQUEST = "ALL_ADMINS_REQUEST";
export const ALL_ADMINS_SUCCESS = "ALL_ADMINS_SUCCESS";
export const ALL_ADMINS_FAIL = "ALL_ADMINS_FAIL";

export const ALL_PMM_REQUEST = "ALL_PMM_REQUEST";
export const ALL_PMM_SUCCESS = "ALL_PMM_SUCCESS";
export const ALL_PMM_FAIL = "ALL_PMM_FAIL";



export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const CLEAR_MESSAGES = "CLEAR_MESSAGES";
















export const UPDATE_PASSWORD_REQUEST = "UPDATE_PASSWORD_REQUEST";
export const UPDATE_PASSWORD_SUCCESS = "UPDATE_PASSWORD_SUCCESS";
export const UPDATE_PASSWORD_FAIL = "UPDATE_PASSWORD_FAIL";
export const UPDATE_PASSWORD_RESET = "UPDATE_PASSWORD_RESET";



export const USER_DETAILS_REQUEST = "USER_DETAILS_REQUEST";
export const USER_DETAILS_SUCCESS = "USER_DETAILS_SUCCESS";
export const USER_DETAILS_FAIL = "USER_DETAILS_FAIL";

export const ALLOW_EDITING_REQUEST = "ALLOW_EDITING_REQUEST";
export const ALLOW_EDITING_SUCCESS = "ALLOW_EDITING_SUCCESS";
export const ALLOW_EDITING_RESET = "ALLOW_EDITING_RESET";
export const ALLOW_EDITING_FAIL = "ALLOW_EDITING_FAIL";

export const CHANGE_ADMIN_REQUEST = "CHANGE_ADMIN_REQUEST";
export const CHANGE_ADMIN_SUCCESS = "CHANGE_ADMIN_SUCCESS";
export const CHANGE_ADMIN_RESET = "CHANGE_ADMIN_RESET";
export const CHANGE_ADMIN_FAIL = "CHANGE_ADMIN_FAIL";







export const CREATE_PRODUCT_MARKET_REQUEST = "CREATE_PRODUCT_MARKET_REQUEST";
export const CREATE_PRODUCT_MARKET_SUCCESS = "CREATE_PRODUCT_MARKET_SUCCESS";
export const CREATE_PRODUCT_MARKET_RESET = "CREATE_PRODUCT_MARKET_RESET";
export const CREATE_PRODUCT_MARKET_FAIL = "CREATE_PRODUCT_MARKET_FAIL";

export const TOGGLE_PRODUCT_MARKET_REQUEST = "TOGGLE_PRODUCT_MARKET_REQUEST";
export const TOGGLE_PRODUCT_MARKET_SUCCESS = "TOGGLE_PRODUCT_MARKET_SUCCESS";
export const TOGGLE_PRODUCT_MARKET_RESET = "TOGGLE_PRODUCT_MARKET_RESET";
export const TOGGLE_PRODUCT_MARKET_FAIL = "TOGGLE_PRODUCT_MARKET_FAIL";

export const ALL_PRODUCT_MARKETS_REQUEST = "ALL_PRODUCT_MARKETS_REQUEST";
export const ALL_PRODUCT_MARKETS_SUCCESS = "ALL_PRODUCT_MARKETS_SUCCESS";
export const ALL_PRODUCT_MARKETS_FAIL = "ALL_PRODUCT_MARKETS_FAIL";





export const DELETE_USER_REQUEST = "DELETE_USER_REQUEST";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_RESET = "DELETE_USER_RESET";
export const DELETE_USER_FAIL = "DELETE_USER_FAIL";

export const UPDATE_CATEGORY_REQUEST = "UPDATE_CATEGORY_REQUEST";
export const UPDATE_CATEGORY_SUCCESS = "UPDATE_CATEGORY_SUCCESS";
export const UPDATE_CATEGORY_RESET = "UPDATE_CATEGORY_RESET";
export const UPDATE_CATEGORY_FAIL = "UPDATE_CATEGORY_FAIL";

export const DELETE_CATEGORY_REQUEST = "DELETE_CATEGORY_REQUEST";
export const DELETE_CATEGORY_SUCCESS = "DELETE_CATEGORY_SUCCESS";
export const DELETE_CATEGORY_RESET = "DELETE_CATEGORY_RESET";
export const DELETE_CATEGORY_FAIL = "DELETE_CATEGORY_FAIL";

export const UPDATE_PRODUCT_MARKET_REQUEST = "UPDATE_PRODUCT_MARKET_REQUEST";
export const UPDATE_PRODUCT_MARKET_SUCCESS = "UPDATE_PRODUCT_MARKET_SUCCESS";
export const UPDATE_PRODUCT_MARKET_RESET = "UPDATE_PRODUCT_MARKET_RESET";
export const UPDATE_PRODUCT_MARKET_FAIL = "UPDATE_PRODUCT_MARKET_FAIL";

export const DELETE_PRODUCT_MARKET_REQUEST = "DELETE_PRODUCT_MARKET_REQUEST";
export const DELETE_PRODUCT_MARKET_SUCCESS = "DELETE_PRODUCT_MARKET_SUCCESS";
export const DELETE_PRODUCT_MARKET_RESET = "DELETE_PRODUCT_MARKET_RESET";
export const DELETE_PRODUCT_MARKET_FAIL = "DELETE_PRODUCT_MARKET_FAIL";

export const DELETE_PRODUCT_TYPE_REQUEST = "DELETE_PRODUCT_TYPE_REQUEST";
export const DELETE_PRODUCT_TYPE_SUCCESS = "DELETE_PRODUCT_TYPE_SUCCESS";
export const DELETE_PRODUCT_TYPE_RESET = "DELETE_PRODUCT_TYPE_RESET";
export const DELETE_PRODUCT_TYPE_FAIL = "DELETE_PRODUCT_TYPE_FAIL";


export const ADMIN_UPDATE_USER_CREDENTIALS_REQUEST = 'ADMIN_UPDATE_USER_CREDENTIALS_REQUEST';
export const ADMIN_UPDATE_USER_CREDENTIALS_SUCCESS = 'ADMIN_UPDATE_USER_CREDENTIALS_SUCCESS';
export const ADMIN_UPDATE_USER_CREDENTIALS_RESET = 'ADMIN_UPDATE_USER_CREDENTIALS_RESET';
export const ADMIN_UPDATE_USER_CREDENTIALS_FAIL = 'ADMIN_UPDATE_USER_CREDENTIALS_FAIL';
